import actions from "./actions";
import mutations from "./mutations";

const state = {
  list: [],
  editedItem: null,
  selectedProduct: null,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
